import Blue from "~/core";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade ]);

// image swiper
new Blue({
	name: 'Swiper Images',
	selector: ".swiper--images",
	setup(swiper) {
		let activeIndexEl = swiper.querySelector('.swiper-count-index');

		console.log("swiper1")
    const swiperMain = new Swiper('.swiper-container--images', {
			slidesPerView: 1.125,
			spaceBetween: 10,
			slideToClickedSlide: true,
			observer: true, 
			observeParents: true,
			threshold: 100,
			thresholdDelta: 100,
			thresholdTime: 500,
			scrollbar: {
				el: ".swiper-scrollbar",
				snapOnRelease: true
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 1.5,
					spaceBetween: 20,
				},
				992: {
					centeredSlides: true,
					slidesPerView: 1.95,
					spaceBetween: 20
				}
			},
			on: {
				init: function() {
					activeIndexEl.innerHTML = this.activeIndex < 10 ? '0' + (this.activeIndex + 1) : (this.activeIndex + 1);
				},
				activeIndexChange: function() {
					activeIndexEl.innerHTML = (this.activeIndex + 1) < 10 ? '0' + (this.activeIndex + 1) : (this.activeIndex + 1);
				}
			}
		}, false);
	}
});

// tour swiper
new Blue({
	name: 'Swiper',
	selector: ".swiper--tours",
	setup(swiper) {
		let activeIndexEl = swiper.querySelector('.swiper-count-index');

		console.log("swiper2")
    const swiperMain = new Swiper('.swiper-container--tours', {
			slidesPerView: 1.125,
			spaceBetween: 10,
			slideToClickedSlide: true,
			observer: true, 
			observeParents: true,
			threshold: 100,
			thresholdDelta: 100,
			thresholdTime: 500,
			scrollbar: {
				el: ".swiper-scrollbar",
				snapOnRelease: true
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 1.5,
					spaceBetween: 20,
				},
				992: {
					centeredSlides: true,
					slidesPerView: 1.95,
					spaceBetween: 20
				}
			},
			on: {
				init: function() {
					activeIndexEl.innerHTML = this.activeIndex < 10 ? '0' + (this.activeIndex + 1) : (this.activeIndex + 1);
				},
				activeIndexChange: function() {
					activeIndexEl.innerHTML = (this.activeIndex + 1) < 10 ? '0' + (this.activeIndex + 1) : (this.activeIndex + 1);
				}
			}
		}, false);
	}
});

// video swiper
new Blue({
	name: 'Swiper',
	selector: ".swiper--videos",
	setup(swiper) {
		let activeIndexEl = swiper.querySelector('.swiper-count-index');
		
		const stopVideo = (className) => {
			let containerElements = swiper.querySelectorAll(className);
			containerElements.forEach(element => {
				let iframeTag = element.querySelector('iframe');
				let videoTag = element.querySelector('video');
				if(videoTag) {
					videoTag.pause();
				}
				if(iframeTag) {
					let iframeSrc = iframeTag.src;
					iframeTag.src = iframeSrc; 
				}
			})
		}

		console.log("swiper3")
    const swiperMain = new Swiper('.swiper-container--videos', {
			slidesPerView: 1.125,
			spaceBetween: 10,
			slideToClickedSlide: true,
			observer: true, 
			observeParents: true,
			threshold: 100,
			thresholdDelta: 100,
			thresholdTime: 500,
			scrollbar: {
				el: ".swiper-scrollbar",
				snapOnRelease: true
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 1.5,
					spaceBetween: 20,
				},
				992: {
					centeredSlides: true,
					slidesPerView: 1.95,
					spaceBetween: 20
				}
			},
			on: {
				init: function() {
					activeIndexEl.innerHTML = this.activeIndex < 10 ? '0' + (this.activeIndex + 1) : (this.activeIndex + 1);
				},
				slideChange: function() {
					stopVideo('.swiper__media-wrapper');
				},
				activeIndexChange: function() {
					activeIndexEl.innerHTML = (this.activeIndex + 1) < 10 ? '0' + (this.activeIndex + 1) : (this.activeIndex + 1);
				}
			}
		}, false);
	}
});

// promo swiper
new Blue({
	name: 'Swiper Promo',
	selector: ".swiper--promo",
	setup(swiper) {
		let activeIndexEl = swiper.querySelector('.swiper-count-index');

		console.log("swiper4")
    const swiperMain = new Swiper('.swiper-container--promo', {
			slidesPerView: 1,
			spaceBetween: 10,
			observer: true, 
			observeParents: true,
			threshold: 100,
			thresholdDelta: 100,
			thresholdTime: 500,
			scrollbar: {
				el: ".swiper-scrollbar",
				snapOnRelease: true
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 2.1,
					spaceBetween: 20,
				},
				1100: {
					slidesPerView: 2.5,
					spaceBetween: 20
				}
			}
		}, false);

		
	}
});

// splash
new Blue({
	name: 'Swiper Splash',
	selector: ".splash-gallery",
	setup(swiperEl) {
		console.log("swiper0")
    const swiperMain = new Swiper(".swiper--splash .swiper-container", {
			slidesPerView: 1,
      effect: "fade",
      speed: 1000,
      loop: true,
      draggable: false,
			observer: true, 
			observeParents: true,
      autoplay: {
        enabled: true,
        disableOnInteraction: false,
        delay: 3000,
      },
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	}
});